<template>
	<el-main class="info-wrap">
		<div class="info-box">
			<div>
				<div class="info-head tc">
					<h3>AI-行业大模型</h3>
				</div>
				<div class="info-content" v-html="infoText"></div>
				
			</div>
		</div>
	</el-main>
</template>

<script>
export default {
	data() {
		return {
			infoText:`<p>“AI-行业大模型”是特规通面向特种设备专业场景打造的智能问答与知识检索引擎，围绕“查得快、答得准、能核验、可追溯”的核心目标，帮助工程技术人员在法规标准体系中快速定位依据、理解条款要求、形成可复用的专业结论，从而显著降低查资料成本，提高设计、制造、检验与运维等环节的工作效率。</p><h3>1）权威数据底座：覆盖广、来源清晰、结构化可用</h3><p>平台收录特种设备行业常用的法律、法规、规章、TSG、行政文件、国家标准、行业标准、技术图书等在内的11类文件，累计3000+份，覆盖八大类特种设备及其全生命周期的关键业务场景。不同于传统“把PDF丢进搜索框”的粗放做法，AI-行业大模型依托自主研发的结构化数据中心技术，对文件进行解析、拆分、标引与结构化重组，将条文、章节、附录、定义、术语、表格、图片、公式等要素形成可计算、可检索、可引用的知识单元，并建立统一的元数据体系（如文件类别、适用设备、环节场景、章节条款编号、图表公式编号等）。这一高质量数据底座，使平台能在复杂规范体系中实现更高精度的检索与引用，也为专业模型训练与AI应用提供了可靠的“行业知识燃料”。</p><h3>2）专业模型与AI应用：两种模式，兼顾速度与深度</h3><p>基于结构化高质量数据，平台进行了特种设备领域的专业模型训练与应用搭建，形成适配工程人员工作习惯的两种问答模式：</p><ul><li>快速回答模式：面向“我要立刻找到依据”的高频需求，系统会快速理解问题意图，在法规标准库中进行精准检索与定位，将答案对应到具体条款，并优先呈现最相关、最可核验的依据内容。该模式适用于现场咨询、设计校核、检验判定、条文比对等需要“快、准、落到条款”的场景，可显著节省翻规范、查目录、找关键词的时间。</li><li>深入思考模式：面向“问题复杂、涉及多个条款与跨文件逻辑”的场景，系统会对用户问题进行更全面的解析，结合行业术语、设备类型、适用环节等信息，在知识库中开展更充分的检索、交叉核验与组合推理，输出更丰富、全面、结构化的回答。该模式适用于方案论证、合规解释、跨文件协调、边界条件分析、学习与培训等需要“讲清楚来龙去脉”的场景，帮助用户把规范要求理解得更透、用得更稳。</li></ul><h3>3）选择书单：限定检索范围，让回答更聚焦</h3><p>为适配不同用户、不同项目、不同业务场景下的个性化使用需求，AI-行业大模型新增“选择书单”功能。客户在“我的书架”模块中创建书单后，可在AI界面直接选择对应书单，系统会将当前问答与知识检索范围限定在该书单所包含的文件集合内。</p><p></p><p>这一机制适用于企业内部培训、专项项目执行、特定设备类型研究、单一标准体系应用等场景。当用户只希望围绕某一批法规标准、技术图书或项目资料开展问答时，无需在全库范围内检索，即可让AI基于选定书单进行更有边界的定位、归纳与回答。相比全库检索，书单限定能够有效减少无关文件干扰，使答案更聚焦当前任务背景，提升检索效率、回答精准度与使用体验。同时，用户也可以根据团队分工、项目主题或学习目标灵活配置多个书单，在不同工作场景间快速切换，形成更加贴合实际业务的专业问答环境。</p><h3>4）可信与可核验：不编造、可溯源、能回到原文</h3><p>特种设备行业具有强规范属性，任何“看似合理但无依据”的回答都可能带来风险。AI-行业大模型在设计上强调可信输出与可核验机制：</p><ol><li>不编造：只基于原文回答 系统以法规标准原文为依据进行回答与归纳，优先呈现条款内容与关键限制条件，避免脱离依据的“凭空推断”。在信息不足或边界不明确时，会提示需要补充的关键参数或适用条件，减少误用。</li><li>可溯源：答案给出处，精确到条款/图表公式 每条结论都会给出对应依据来源，支持精确到条款号、图片/公式/表格编号，并提供一键跳转回原文查看。用户不仅“得到结论”，更能“看到依据、核对原文、把结论带走”，满足工程场景对审查、留痕与复核的要求。</li><li>专业全面：覆盖设备与全流程，能答从业者的关键问题 知识覆盖八大类特种设备相关的设计、制造、安装、检验检测、使用管理、维护保养、风险与安全等全环节，并延展至附属相关知识与常见工程问题。无论是新入行人员的学习型提问，还是资深工程师的条款核验与边界判断，都能获得可落地、可引用、可复核的支持。</li></ol><h3>5）面向真实工作：让“查资料、看规范、学标准”更简单</h3><p>传统查规范往往面临“文件多、体系复杂、条文散、跨文件引用多、图表公式难定位”等痛点。AI-行业大模型把这些工作从“人工翻找”转化为“智能定位+依据核验”的流程：用户提出问题，系统在秒级/分钟级内完成意图理解、条款定位、依据呈现与结构化解释；当结合“选择书单”功能使用时，还可以进一步将问答限定在具体任务所需的资料范围内，减少检索噪音，提升结论聚焦度，显著减少资料检索与反复确认的时间，让工程人员把更多精力用在方案与决策上。</p><p></p><p>总之，“AI-行业大模型”不是通用聊天工具的简单套壳，而是建立在特种设备专业知识资产之上的行业级能力：以高质量结构化知识库为底座，以可追溯可核验为原则，以工程场景为导向，并通过“选择书单”等个性化能力帮助用户在特定资料范围内开展更精准的专业问答，支持每一位从业者更高效、更稳妥地用好法规标准，提升工作效率与合规质量。</p><p><br></p>`
		};
	}
};
</script>

<style lang="less" scoped>
.info-wrap {
	margin-left: 20px;
	padding: 20px 0 !important;
	font-size: 14px;
	color: #686f83;
	line-height: 1.8;
	background-color: #ffffff;
	box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
	border-radius: 15px;
	 min-height: calc(100vh - 120px);
	h3 {
		margin: 0 0 10px;
		font-weight: 400;
		font-size: 24px;
		color: #333333;
	}
}
.info-item {
	margin-bottom: 20px;
}
.info-head {
	margin-bottom: 25px;
	padding-bottom: 15px;
	border-bottom: 1px solid #cccccc;
	.topbox {
		color: #888888;
		dd {
			margin: 0 30px 0 0;
		}
	}
}
</style>

<style lang="less">
.info-content {
	// text-indent: 2em;
	padding: 0 30px;
	color: #1f2329;
}

.info-content ul, .info-content ol, .info-content dl, .info-content li::marker, .info-content dd, .info-content dt{
    // list-style: normal;
}

.info-content li::marker {
    color: rgb(20, 86, 240);
}

.info-content p {
	margin: 0;
}

.info-content h5 {
	color: #1f2329;
	font-size: 16px;
	margin: 0;
	padding: 0;
	line-height: 34px;
	margin-top: 10px;
}

.info-content h6 {
	color: #1f2329;
	font-size: 16px;
	margin: 0;
	padding: 0;
	line-height: 34px;
	position: relative;
}
.info-content h6:before {
	content: ' ';
	display: inline-block;
	width: 5px;
	height: 5px;
	background: #1474e2;
	border-radius: 50%;
	margin-right: 10px;
	position: absolute;
	top: 16px;
	left: 18px;
}

.info-box {
	padding-bottom: 30px;
}
</style>
